import { render, staticRenderFns } from "./AddStudentMap.vue?vue&type=template&id=2ef0a87a&"
import script from "./AddStudentMap.vue?vue&type=script&lang=js&"
export * from "./AddStudentMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports